






















































































































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Vue from 'vue';

import VoteMixins from './mixins';

@Component
export default class VotePage extends mixins(Vue, VoteMixins) {
  get showVotePageContent() {
    return process.env.VUE_APP_CLIENT != 'akum';
  }
}
